let config = {};

config.api_url = process.env.REACT_APP_API_ENDPOINT;
config.image_url = process.env.REACT_APP_IMAGE_URL;
config.db_name = process.env.REACT_APP_DBNAME;
config.qdm_admin_url = process.env.REACT_APP_QDM_ADMIN_ENDPOINT;
config.compiler_url = process.env.REACT_APP_COMPILER;
export default config;
